import api from "../api";

import Logo from "../assets/img/logo-achemed.png";
import { Link, Navigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import List from "./../assets/img/list.svg";
import Logout from "./../assets/img/exit.svg";
import ModalYesNo from "./ModalYesNo";
import { useState, useEffect } from "react";
import ACHEMED24h from "../assets/img/hospital-_1_.svg";
import { Calendar as CalendarIcon, Settings } from "lucide-react";

import LogoutIMGModal from "../assets/img/logoutImg.svg";
// import Client from "../assets/img/clients-im.svg";
// import Doctor from "../assets/img/doctor.svg";
// import Agreements from "../assets/img/plano-de-saude.svg";
import Report from "../assets/img/relatorio.svg";
// import Shopper from "../assets/img/hospital.svg";
// import Users from "../assets/img/silhueta-de-multiplos-usuarios.svg";
import Money from "../assets/img/fatura.svg";
// import CallCenter from "../assets/img/central-de-atendimento.svg";
import PosConsult from "../assets/img/PosConsultorioWhite.svg";
// import Pharmacy from "../assets/img/pharmacy.svg";
// import Flask from "../assets/img/flask.svg";
// import ConicalFlask from "../assets/img/conical-flask.svg";

import BarChart from "../assets/img/bar-chart.svg";

function Menu({ screen }) {
  const [username, setUsername] = useState("");
  const { setUser, hasRole } = useStateContext();

  useEffect(() => {
    var expires = new Date(localStorage.getItem("EXPIRES_TOKEN"));
    var atual_date = new Date();

    if (atual_date >= expires) {
      localStorage.removeItem("ACCESS_TOKEN");
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    api
      .get("api/user/authenticated")
      .then((response) => {
        setUser(response.data.data);

        const parts = response.data.data.name.split(" ");
        const firstNames = parts.slice(0, 2).join(" ");
        const lower = firstNames.toLowerCase();
        const capitalizedNames = lower
          .split(" ")
          .map((name) => name.charAt(0).toUpperCase() + name.slice(1))
          .join(" ");
        setUsername(capitalizedNames);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const { token } = useStateContext();
  const [showModal, setShowModal] = useState(false);

  if (!token) {
    return <Navigate to="/login" />;
  }

  const onLogout = () => {
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem("userRole");
    window.location.reload();
  };

  const sidebarToggle = () => {
    const sidebarToggleConst = document.body.querySelector("#sidebarToggle");
    if (sidebarToggleConst) {
      document.body.classList.toggle("sb-sidenav-toggled");
      localStorage.setItem(
        "sb|sidebar-toggle",
        document.body.classList.contains("sb-sidenav-toggled")
      );
    }
  };

  return (
    <>
      <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
        <a
          style={{ display: "flex" }}
          className=" align-items-center navbar-brand ps-3 justify-content-center"
          href="/">
          {" "}
          <img
            style={{ marginRight: 10 }}
            width={125}
            alt="logo"
            src={Logo}
          />{" "}
          Codex{" "}
        </a>
        <button
          onClick={sidebarToggle}
          className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0"
          id="sidebarToggle"
          href="#!">
          <i className="fas fa-bars"></i>

          <img alt="menu" width={30} src={List} />
        </button>
        <div className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0"></div>
        <span className=" btn btn-link navbar-nav ms-auto ms-md-0 me-3 me-lg-2"></span>
      </nav>
      <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
          <nav
            className="sb-sidenav accordion sb-sidenav-dark"
            id="sidenavAccordion">
            <div className="sb-sidenav-menu pt-3">
              <div className="nav">

                <Link
                  onClick={() => {
                    setTimeout(() => {
                      if (window.screen.width < 993) {
                        sidebarToggle();
                      }
                    }, 500);
                  }}
                  className="nav-link link-menu align-items-start"
                  to="/dashboard">
                  <img className="img-menu" alt="dashboard" src={BarChart} />{" "}
                  <span>Dashboard</span>{" "}
                </Link>

                {(
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/settings">
                    <Settings className="img-menu" />
                    <span>Administrativo</span>{" "}
                  </Link>
                )}

                {hasRole(["Administrator"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/prontoatendimento">
                    <img
                      className="img-menu"
                      alt="pronto atendimento"
                      src={ACHEMED24h}
                    />{" "}
                    <span>Pronto Atendimento</span>{" "}
                  </Link>
                )}

                {hasRole(["Administrator", "Receptionist"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/pos-consultorio">
                    <img
                      className="img-menu"
                      alt="pos consultorio"
                      src={PosConsult}
                    />{" "}
                    <span>Pós-Consultório</span>{" "}
                  </Link>
                )}

                {/* {hasRole([
                  "Administrator",
                  "OnSiteSupport",
                  "OnlineSupport",
                  "ProjectManager",
                ]) && (
                    <Link
                      onClick={() => {
                        setTimeout(() => {
                          if (window.screen.width < 993) {
                            sidebarToggle();
                          }
                        }, 500);
                      }}
                      className="nav-link link-menu align-items-start"
                      to="/users">
                      <img className="img-menu" alt="users" src={Users} />
                      <span>Usuários</span>{" "}
                    </Link>
                  )} */}

                {/* {hasRole([
                  "Administrator",
                  "Finance",
                  "OnSiteSupport",
                  "OnlineSupport",
                  "ProjectManager",
                ]) && (
                    <Link
                      onClick={() => {
                        setTimeout(() => {
                          if (window.screen.width < 993) {
                            sidebarToggle();
                          }
                        }, 500);
                      }}
                      className="nav-link link-menu align-items-start"
                      to="/shoppers">
                      <img className="img-menu" alt="shoppers" src={Shopper} />
                      <span>Clientes</span>{" "}
                    </Link>
                  )} */}

                {/* {hasRole([
                  "Administrator",
                  "Finance",
                  "OnSiteSupport",
                  "OnlineSupport",
                  "ProjectManager",
                  "Receptionist",
                ]) && (
                    <Link
                      onClick={() => {
                        setTimeout(() => {
                          if (window.screen.width < 993) {
                            sidebarToggle();
                          }
                        }, 500);
                      }}
                      className="nav-link link-menu align-items-start"
                      to="/partners">
                      <img className="img-menu" alt="partners" src={Shopper} />
                      <span>Locais de Atendimento</span>{" "}
                    </Link>
                  )} */}

                {/* {hasRole(["Administrator", "Receptionist"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/customers">
                    <img className="img-menu" alt="customers" src={Client} />
                    <span>Pacientes</span>{" "}
                  </Link>
                )} */}

                {/* {hasRole([
                  "Administrator",
                  "Finance",
                  "OnSiteSupport",
                  "OnlineSupport",
                  "ProjectManager",
                  "Receptionist",
                ]) && (
                    <Link
                      onClick={() => {
                        setTimeout(() => {
                          if (window.screen.width < 993) {
                            sidebarToggle();
                          }
                        }, 500);
                      }}
                      className="nav-link link-menu align-items-start"
                      to="/professionals">
                      <img
                        className="img-menu"
                        alt="professionals"
                        src={Doctor}
                      />
                      <span>Profissionais</span>{" "}
                    </Link>
                  )} */}

                {/* {hasRole(["Administrator", "Finance", "ProjectManager"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/agreements">
                    <img
                      className="img-menu"
                      alt="agreements"
                      src={Agreements}
                    />
                    <span>Convênios</span>{" "}
                  </Link>
                )} */}

                {hasRole(["Administrator", "Finance", "ProjectManager"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/reports">
                    <img className="img-menu" alt="dashboard" src={Report} />
                    <span>Relatórios</span>{" "}
                  </Link>
                )}

                {/* {hasRole(["Administrator"]) && (
                  <Link className="nav-link link-menu align-items-start" to="/">
                    <img
                      className="img-menu"
                      alt="dashboard"
                      src={CallCenter}
                    />
                    <span>Atendimento</span>{" "}
                  </Link>
                )} */}

                {hasRole(["Administrator", "Finance"]) && (
                  <Link
                    className="nav-link link-menu align-items-start"
                    to="/financial">
                    <img className="img-menu" alt="dashboard" src={Money} />
                    <span>Financeiro</span>{" "}
                  </Link>
                )}

                {hasRole(["Administrator", "Finance", "ProjectManager"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/schedule">
                    <CalendarIcon className="img-menu" />
                    <span>Agenda</span>{" "}
                  </Link>
                )}

                {/* {hasRole(["Administrator", "Receptionist"]) && (
                  <Link
                    onClick={() => {
                      setTimeout(() => {
                        if (window.screen.width < 993) {
                          sidebarToggle();
                        }
                      }, 500);
                    }}
                    className="nav-link link-menu align-items-start"
                    to="/procedures">
                    <img className="img-menu" alt="dashboard" src={ConicalFlask} />
                    <span>Procedimentos</span>{" "}
                  </Link>
                )} */}

                {/* {hasRole(["Administrator", "Financial", "ProjectManager"]) && (
                  <Link
                    className="nav-link link-menu align-items-start"
                    to="/pharmacies">
                    <img className="img-menu" alt="dashboard" src={Pharmacy} />
                    <span>Farmácias</span>{" "}
                  </Link>
                )} */}

                {/* {hasRole(["Administrator", "Financial", "ProjectManager"]) && (
                  <Link
                    className="nav-link link-menu align-items-start"
                    to="/labs">
                    <img className="img-menu" alt="dashboard" src={Flask} />
                    <span>Laboratórios / Fabricantes</span>{" "}
                  </Link>
                )} */}
              </div>
            </div>
            <div
              style={{ display: "flex" }}
              className="align-items-center sb-sidenav-footer justify-content-between py-4">
              <div>
                <div className="small">Logado como:</div>
                {username}
                <span className=" btn btn-link navbar-nav ms-auto ms-md-0 me-3 me-lg-2"></span>
              </div>
              <img
                onClick={() => setShowModal(true)}
                style={{ cursor: "pointer", width: 25 }}
                alt="logout"
                src={Logout}
              />
            </div>
          </nav>
        </div>
        <div id="layoutSidenav_content">
          <main>{screen}</main>
        </div>
      </div>
      <ModalYesNo
        title={"Logout"}
        show={showModal}
        message={"Tem certeza que deseja sair?"}
        imgSVG={LogoutIMGModal}
        setShow={setShowModal}
        afirmativeFunc={onLogout}
        affirnName={"Sair"}
        negName={"Voltar"}
      />
    </>
  );
}
export default Menu;
